import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import Forms from "@/pages/admin/Forms";
import { buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/admin/forms")({
  head: () =>
    buildSeoHead(
      { ...publicPageSeo.home, key: "admin-forms", path: "/admin/forms", title: "Cloud Admin Forms", description: "Form responses" },
      [],
      { noindex: true },
    ),
  component: () => <AdminLayout><Forms /></AdminLayout>,
});
